import React, { Component } from "react";
import { Row, Col, Container, Form, Button, Table, Image, Card } from "react-bootstrap";
import axios, { post } from "axios";
import Camera from "../studentAdmission/camera"
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import moment, { invalid } from "moment";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import "./_gatePass.scss"
import dummiImage from "../../../images/businessman.png"
import jsPDF from "jspdf";

const ADD_INANDOUT_DETAILS = gql`
  mutation($params: AddPermissionDetails) {
    addInAndOutStatus(params: $params)
  }`

// ── Finance-style shared inline styles ──────────────────────────────
const FIN = {
    wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
    card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" },
    cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
    iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
    cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
    cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
    cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
    filterBar: { padding: "18px 24px", borderBottom: "1px solid #f3f4f6" },
    label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: ".3px" },
    input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%", height: 42 },
    btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", width: "100%", height: 42 },
    btnSuccess: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#059669", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", width: "100%", height: 42 },
    btnOutline: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#f5f3ff", color: "#7c3aed", border: "1px solid #ddd6fe", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
    content: { padding: "24px" },
    resultCard: { background: "#fff", border: "1px solid #eef2f7", borderRadius: 14, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", padding: 24 },
    seg: { display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 18px", borderRadius: 9, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#64748b", fontSize: 13, fontWeight: 600, cursor: "pointer", userSelect: "none" },
    segActiveOut: { display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 18px", borderRadius: 9, border: "1.5px solid #fca5a5", background: "#fef2f2", color: "#dc2626", fontSize: 13, fontWeight: 700, cursor: "pointer", userSelect: "none" },
    segActiveIn: { display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 18px", borderRadius: 9, border: "1.5px solid #6ee7b7", background: "#ecfdf5", color: "#059669", fontSize: 13, fontWeight: 700, cursor: "pointer", userSelect: "none" },
};

class GatePassSection extends Component {
    constructor(props) {
        super();
        this.state = {
            rollno_mobile: "",
            rollno_mobile_error: "",
            student_details: [],
            dataError: "",
            loading: 0,
            camera: false,
            cameraFileOpen: "",
            inOutReceiverLogoFilePath: "",
            inOutReceiverImagePreviewUrl: "",
            inOutReceiverLogoFilePath: "",
            file: "",
            selectedOptionId: "1",
            submitted: false,
            submitError: "",
            isCardVisible: true,
            showDownloadButton: false,
            beforeSubmitted: false,
            currentDateandTime: new Date(),
            reqDate: "",
            reqDate_error: "",
            requested_date_array: []
        }
    }
    async fileUpload(selectedFile, base64Data) {
        try {
            const response = await this.props.client.mutate({
                mutation: gql`
                            mutation FileUpload($params: FileUploadInput!) {
                                fileUpload(params: $params) {
                                    uuid
                                    file_url
                                    file_extension_type
                                    file_name
                                }
                            }
                        `,
                variables: {
                    params: {
                        category: "admissions",
                        client_id: parseInt(Cookies.get("institutionid")),
                        file: [
                            {
                                img: base64Data,
                                filename: selectedFile.name
                            }
                        ]
                    }
                }
            });
            const fileUploadResult = response?.data?.fileUpload;
            return Array.isArray(fileUploadResult) ? fileUploadResult[0] : fileUploadResult;
        } catch (error) {
            console.error("File upload error:", error);
            throw error;
        }
    }

    parenthandleinputchange = async (e) => {
        let file = {
            name: "testing.jpeg",
        }

        const upload = await this.fileUpload(file, e);

        console.log("upload", upload);

        if (upload && upload.file_url) {
            this.setState({
                inOutReceiverLogoFilePath: upload.file_url,
                inOutReceiverImagePreviewUrl: e,
            });
        }
    }

    handleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "rollno_mobile") {

            let requested_date_array = []
            if (value !== "") {
                if (this.props.getParentsPermissionDetails.filter((i) => (i.permission_status == 1).length > 0)) {
                    requested_date_array = this.props.getParentsPermissionDetails.filter((item) => item.roll_no == value || item.student_mobile == value)
                }
                console.log("dates", requested_date_array);
            }
            this.setState({
                rollno_mobile: value,
                rollno_mobile_error: "",
                dataError: "",
                student_details: [],
                loading: 0,
                showDownloadButton: false,
                inOutReceiverLogoFilePath: "",
                inOutReceiverImagePreviewUrl: "",
                inOutReceiverLogoFilePath: "",
                beforeSubmitted: false,
                reqDate: "",
                requested_date_array: requested_date_array

            })
        }
        if (name == "radioOption") {
            this.setState({
                selectedOptionId: e.target.id,
                student_details: [],
                rollno_mobile: "",
                showDownloadButton: false,
                inOutReceiverLogoFilePath: "",
                inOutReceiverImagePreviewUrl: "",
                inOutReceiverLogoFilePath: "",
                reqDate: "",
                beforeSubmitted: false
            })
        }
        if (name == "reqDate") {
            this.setState({
                reqDate: value,
                reqDate_error: "",
                student_details: [],
                showDownloadButton: false,
                inOutReceiverLogoFilePath: "",
                inOutReceiverImagePreviewUrl: "",
                inOutReceiverLogoFilePath: "",
            })
        }


    }

    getApprovedStudent = () => {
        if (this.state.rollno_mobile == "") {
            this.setState({
                rollno_mobile_error: "Please Enter Roll No",
                loading: 0
            })
            return ""
        }
        if (this.state.reqDate == "") {
            this.setState({
                reqDate_error: "Please select Date",
                loading: 0
            })
            return ""
        }
        this.setState({
            loading: 1
        })

        if (this.props.getParentsPermissionDetails.filter((i) => (i.permission_status == 1).length > 0)) {
            var filterData = this.props.getParentsPermissionDetails.filter((item) => (item.roll_no == this.state.rollno_mobile || item.student_mobile == this.state.rollno_mobile) && moment.unix(item.from_datetime).format("DD-MM-YYYY") == this.state.reqDate)
            console.log("filterdata", filterData);
            if (filterData.length > 0) {
                if ((filterData[0].outtime == "" || filterData[0].outtime == null) && this.state.selectedOptionId == "1") {
                    console.log("btnnnn1");
                    this.setState({
                        student_details: filterData,
                        loading: 0
                    })
                    console.log("kk", filterData.outtime_image_path == "" && this.state.selectedOptionId == "1");
                } else if ((filterData[0].intime == "" || filterData[0].intime == null) && this.state.selectedOptionId == "2") {
                    console.log("btnnnn2");

                    this.setState({
                        student_details: filterData,
                        loading: 0
                    })
                } else {
                    console.log("btnnnn3");
                    this.setState({ showDownloadButton: true, loading: 0, beforeSubmitted: true })
                }

            } else {
                this.setState({ dataError: "No Data Found", loading: 0, student_details: [] })

            }
        } else {
            this.setState({ dataError: "No Data Found", loading: 0, student_details: [] })

        }

    }

    handleImageSubmit = () => {
        let inTimeImagePath = ""
        if (this.state.selectedOptionId == 2 && this.state.inOutReceiverLogoFilePath != "") {
            inTimeImagePath = this.state.inOutReceiverLogoFilePath

        }
        let outTimeImagePath = ""
        if (this.state.selectedOptionId == 1 && this.state.inOutReceiverLogoFilePath != "") {
            outTimeImagePath = this.state.inOutReceiverLogoFilePath
        }
        const params = {
            inOrOut_id: parseInt(this.state.selectedOptionId),
            outtime_image_path: outTimeImagePath,
            intime_image_path: inTimeImagePath,
            permission_id: this.state.student_details[0].permission_id
        }



        this.setState({
            loading: 2
        });

        this.addInAndOutDetails(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log("params", params);
            console.log(error);


            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loading: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        setTimeout(() => {
            this.SetpageLoad()
        }, 3000)
        this.handleDownload()
    }

    addInAndOutDetails = async (
        params) => {
        await this.props.addInAndOutDetails({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addInAndOutStatus) {
                    this.setState({
                        loading: 0,
                        submitted: true
                    })

                }
            }

        });

    };
    SetpageLoad = () => {
        this.setState({ submitted: false, submitError: "", loading: 0 });
        window.location.reload(false);
    };

    handleDownload = () => {

        if (this.props.getParentsPermissionDetails.filter((i) => i.outtime != "" && i.outtime != null)) {

            console.log("dataaaa", this.props.getParentsPermissionDetails.filter((item1) => {
                console.log("item1", item1);
            }));
            var filter_data = this.props.getParentsPermissionDetails.filter((item) => (item.roll_no == this.state.rollno_mobile || item.student_mobile == this.state.rollno_mobile) && (moment.unix(item.from_datetime).format("DD-MM-YYYY") == this.state.reqDate))
        }

        console.log("dd", filter_data);

        const logo = this.props.getOrganisationProfile.logo
        console.log("logo",);
        const address = this.props.getOrganisationProfile.complete_address
        const image = `https://support.rizee.in/files/${logo}`
        const collegeName = this.props.getOrganisationProfile.organisation_name

        const doc = new jsPDF();
        doc.rect(15, 15, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 182);

        let capturReceiverImage = "";
        let outDate = "";
        let outTime = "";
        let message = ""

        if (this.state.beforeSubmitted) {
            if (this.state.selectedOptionId == 1) {
                capturReceiverImage = `${filter_data[0].outtime_image_path}`;
                outDate = moment.unix(filter_data[0].outtime).format("DD-MM-YYYY");
                outTime = moment.unix(filter_data[0].outtime).format(" HH:mm:ss");
                message = "out";
            } else {
                capturReceiverImage = `${filter_data[0].intime_image_path}`;
                outDate = moment.unix(filter_data[0].intime).format("DD-MM-YYYY");
                outTime = moment.unix(filter_data[0].intime).format(" HH:mm:ss");
                message = "In"
            }
        } else {
            if (this.state.inOutReceiverLogoFilePath != "") {

                // debugger;
                let date = this.state.currentDateandTime;
                console.log("date", date);
                let day = date.getDate();
                let month = date.getMonth() + 1;
                let year = date.getFullYear();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let seconds = date.getSeconds();

                outDate = `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
                outTime = `${hours}:${minutes}:${seconds}`;

                capturReceiverImage = this.state.inOutReceiverLogoFilePath;
                if (this.state.selectedOptionId == 1) {
                    message = "Out"
                } else {
                    message = "In"
                }

            }
        }

        let sName = ""
        let sRoll = ""
        let recieverName = ""

        if (filter_data[0].student_name != "" && filter_data[0].student_name != null) {
            sName = filter_data[0].student_name
        } else {
            sName = "--"
        }

        if (filter_data[0].roll_no != "" && filter_data[0].roll_no != null) {
            sRoll = filter_data[0].roll_no
        } else {
            sRoll = "--"
        }

        if (filter_data[0].receiver_name != "" && filter_data[0].receiver_name != null) {
            recieverName = filter_data[0].receiver_name
        } else {
            recieverName = "--"
        }

        const msg = `${message}Time Receiver Image:`
        const recieverImage = `${filter_data[0].receiver_image_path}`
        const signatureX = 150;
        const signatureY = 120
        const signatureFontSize = 12;
        const signatureUnderlineX = signatureX;
        const signatureUnderlineY = signatureY + 7;
        const signatureUnderlineWidth = doc.getStringUnitWidth("Authorized Sign") + 38;
        const signatureUnderlineHeight = 0.2;

        doc.setFontSize(signatureFontSize);
        doc.text("Authorized Sign", signatureX, signatureY);


        doc.setLineWidth(signatureUnderlineHeight);
        doc.line(signatureUnderlineX, signatureUnderlineY, signatureUnderlineX + signatureUnderlineWidth, signatureUnderlineY);



        const imgData = image
        const imgWidth = 28;
        const imgHeight = 17;
        doc.addImage(imgData, 'JPEG', 25, 20, imgWidth, imgHeight);
        const adressSize = 11
        doc.setFontSize(adressSize)
        doc.text(address, 58, 31)
        const imgWidth1 = 25;
        const imgHeight1 = 29;
        doc.addImage(recieverImage, 'JPEG', 35, 88, imgWidth1, imgHeight1);
        doc.addImage(capturReceiverImage, 'JPEG', 79, 88, imgWidth1, imgHeight1);
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(13);
        doc.text(`Student Name:`, 25, 60);
        doc.text(`Student RollNo:`, 25, 68);
        doc.text(`Reciever Name:`, 25, 76);
        doc.text(`Reciever Image:`, 25, 84);
        doc.text(`Date:`, 150, 52);
        doc.text(`Time:`, 150, 58);
        doc.text(msg, 68, 85)

        const studentName = sName;
        const studentRoll = sRoll;
        const RecieverName = recieverName
        const Date = `${outDate.toString()}`
        const Time = `${outTime.toString()}`
        doc.setFont('Helvetica', 'none');
        doc.setFontSize(14);
        doc.text(studentName, 65, 60);
        doc.text(studentRoll, 65, 68);
        doc.text(RecieverName, 65, 76);
        doc.text(Date, 165, 52);
        doc.text(Time, 165, 58);



        const headingX = 74;
        const headingY = 49;
        const headingFontSize = 15;
        const underlineX = headingX;
        const underlineY = headingY + 2;
        const underlineWidth = doc.getStringUnitWidth("STUDENT PASS") + 35;
        const underlineHeight = 0.5;

        doc.setFont(undefined, 'bold');
        doc.setFontSize(headingFontSize);
        doc.text("STUDENT PASS", headingX, headingY);


        doc.setLineWidth(underlineHeight);
        doc.line(underlineX, underlineY, underlineX + underlineWidth, underlineY);
        const collegeSize = 17;
        doc.setFontSize(collegeSize)
        doc.text(collegeName, 58, 25)
        doc.save(`${filter_data[0].roll_no}.pdf`);
    }

    render() {



        return (
            <div style={FIN.wrapper}>
                <Container fluid className="px-0">
                    <div style={FIN.card}>
                        {/* Header */}
                        <div style={FIN.cardHeader}>
                            <div style={FIN.iconWrapper}><i className="fal fa-id-badge" /></div>
                            <div style={FIN.cardTitleText}>
                                <h5 style={FIN.cardTitle}>Student Gate Pass</h5>
                                <span style={FIN.cardSubtitle}>Record student exit &amp; entry and print the gate pass</span>
                            </div>
                        </div>

                        {/* Search bar */}
                        <div style={FIN.filterBar}>
                            {/* IN / OUT toggle */}
                            <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
                                <label style={this.state.selectedOptionId === "1" ? FIN.segActiveOut : FIN.seg}>
                                    <input type="radio" name="radioOption" id="1" onChange={this.handleInputChange} checked={this.state.selectedOptionId === "1"} style={{ display: "none" }} />
                                    <i className="fas fa-sign-out-alt" /> OUT
                                </label>
                                <label style={this.state.selectedOptionId === "2" ? FIN.segActiveIn : FIN.seg}>
                                    <input type="radio" name="radioOption" id="2" onChange={this.handleInputChange} checked={this.state.selectedOptionId === "2"} style={{ display: "none" }} />
                                    <i className="fas fa-sign-in-alt" /> IN
                                </label>
                            </div>

                            <Row className="g-2 align-items-end">
                                <Col xl={3} lg={4} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>RollNo / Mobile</label>
                                    <input
                                        type="text"
                                        name="rollno_mobile"
                                        style={FIN.input}
                                        placeholder="Enter RollNo / Mobile"
                                        onChange={this.handleInputChange}
                                        value={this.state.rollno_mobile}
                                    />
                                    {this.state.rollno_mobile_error ? (
                                        <span style={{ color: "#dc2626", fontSize: 12 }}>{this.state.rollno_mobile_error}</span>
                                    ) : null}
                                </Col>
                                <Col xl={3} lg={4} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Select Request Date</label>
                                    <select
                                        name="reqDate"
                                        style={FIN.input}
                                        onChange={this.handleInputChange}
                                        value={this.state.reqDate}
                                    >
                                        <option value="">-- Select --</option>
                                        {this.state.requested_date_array.map((item, idx) => {
                                            const d = moment.unix(item.from_datetime).format("DD-MM-YYYY");
                                            return <option key={idx} value={d}>{d}</option>;
                                        })}
                                    </select>
                                    {this.state.reqDate_error ? (
                                        <span style={{ color: "#dc2626", fontSize: 12 }}>{this.state.reqDate_error}</span>
                                    ) : null}
                                </Col>
                                <Col xl={2} lg={2} md={6} sm={12} className="mb-2">
                                    <button style={FIN.btnPrimary} onClick={() => this.getApprovedStudent()}>
                                        <i className="fas fa-search" /> Get Student
                                    </button>
                                </Col>
                                {this.state.showDownloadButton == true ? (
                                    <Col xl={2} lg={2} md={6} sm={12} className="mb-2">
                                        <button style={FIN.btnSuccess} onClick={this.handleDownload}>
                                            <i className="fas fa-download" /> Download Pass
                                        </button>
                                    </Col>
                                ) : null}
                            </Row>

                            {this.state.dataError ? (
                                <div style={{ marginTop: 12, background: "#fef2f2", border: "1px solid #fecaca", color: "#dc2626", borderRadius: 9, padding: "10px 14px", fontSize: 13, display: "flex", alignItems: "center", gap: 8 }}>
                                    <i className="fas fa-exclamation-circle" />{this.state.dataError}
                                </div>
                            ) : null}

                            {this.state.loading == 1 ? (
                                <div style={{ marginTop: 12 }}>
                                    <span className="spinner-border spinner-border-sm" style={{ color: "#7c3aed" }} />
                                </div>
                            ) : null}
                        </div>

                        {/* Result */}
                        <div style={FIN.content}>
                            {this.state.student_details.length > 0 ? (
                                <div style={FIN.resultCard}>
                                    <Row>
                                        <Col lg={6} md={12} sm={12} className="mb-3">
                                            <div style={{ display: "flex", gap: 18, alignItems: "flex-start" }}>
                                                <img
                                                    src={(this.state.student_details[0].receiver_image_path != null && this.state.student_details[0].receiver_image_path != "") ? this.state.student_details[0].receiver_image_path : dummiImage}
                                                    alt=""
                                                    width={130}
                                                    height={150}
                                                    style={{ borderRadius: 12, objectFit: "cover", border: "1px solid #e5e7eb" }}
                                                />
                                                <div style={{ fontSize: 14, color: "#334155", lineHeight: 2 }}>
                                                    <div>Student Name : <b style={{ color: "#0f172a" }}>{this.state.student_details[0]?.student_name || "--"}</b></div>
                                                    <div>Roll Number : <b style={{ color: "#0f172a" }}>{this.state.student_details[0]?.roll_no || "--"}</b></div>
                                                    <div>Reciever Name : <b style={{ color: "#0f172a" }}>{(this.state.student_details[0]?.receiver_name != null && this.state.student_details[0]?.receiver_name != "") ? this.state.student_details[0]?.receiver_name : "--"}</b></div>
                                                    <div>Reciever Mobile : <b style={{ color: "#0f172a" }}>{(this.state.student_details[0]?.receiver_mobile != null && this.state.student_details[0]?.receiver_mobile != "") ? this.state.student_details[0]?.receiver_mobile : "--"}</b></div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={6} md={12} sm={12} className="mb-3">
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
                                                {this.state.inOutReceiverImagePreviewUrl ? (
                                                    <Image src={`${this.state.inOutReceiverImagePreviewUrl}`} style={{ width: 160, height: "29vh", objectFit: "cover", borderRadius: 12, border: "1px solid #e5e7eb" }} />
                                                ) : (
                                                    <div style={{ width: 160, height: "29vh", border: "1.5px dashed #cbd5e1", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: 13, background: "#f8fafc" }}>
                                                        Upload Image
                                                    </div>
                                                )}
                                                <button style={FIN.btnOutline} onClick={() => this.setState({ camera: true })}>
                                                    <i className="fas fa-camera" /> Capture Image
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div style={{ textAlign: "center", marginTop: 8 }}>
                                        <button style={{ ...FIN.btnPrimary, width: "auto", padding: "10px 32px" }} onClick={this.handleImageSubmit}>
                                            {this.state.loading == 2 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-check" />}
                                            Submit
                                        </button>
                                        <div>
                                            {this.state.submitted == true ? (
                                                <p style={{ color: "#059669", marginTop: 8, fontWeight: 600 }}>Status Submitted</p>
                                            ) : null}
                                            {this.state.submitError != "" ? (
                                                <span style={{ color: "#dc2626", marginTop: 8 }}>{this.state.submitError}</span>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Container>

                <Camera
                    stateData={this.state}
                    show={this.state.camera}
                    parenthandleinputchange={this.parenthandleinputchange}
                    onHide={() => this.setState({ camera: false })}
                />
            </div>
        )
    }
}
export default withRouter(withApollo(compose(
    graphql(ADD_INANDOUT_DETAILS, {
        name: "addInAndOutDetails"
    })

)(GatePassSection)));
